// HTTP 402 = a gravação esbarrou no plano da conta (só leitura, ou 2º vínculo no plano
// grátis — ADR 0010). O httpClient avisa o app por este evento de window, sem depender de
// React; quem oferece a assinatura (PlanoBloqueadoModal, no AppShell) escuta.
export const PLANO_BLOQUEADO_EVENT = "medhub:plano-bloqueado";

export function isPlanoBloqueado(error) {
  return error?.response?.status === 402;
}

export function avisarPlanoBloqueado(mensagem) {
  window.dispatchEvent(new CustomEvent(PLANO_BLOQUEADO_EVENT, { detail: { mensagem } }));
}
